module.exports = __webpack_public_path__ + "img/dice-2.ad4eb7bc.svg";